const alt = require('components/alt');
const LPListingsActions = require('./lp_listings_actions.js');

class LPListingsStore {
  constructor() {
    this.resetState();

    this.bindListeners({
      handleListingsLoaded: LPListingsActions.LP_LISTINGS_LOADED,
    });
  }

  handleListingsLoaded(listings) {
    this.lpListings = listings;
  }

  resetState() {
    this.lpListings = [];
  }
}

module.exports = alt.createStore(LPListingsStore, 'LPListingsStore');



// WEBPACK FOOTER //
// ./javascripts/components/lp_listings/lp_listings_store.js